import { createReducer, on } from "@ngrx/store";
import { clearMaintenanceTime, setMaintenanceTime } from "./maintenance.actions";
import { initialMaintenanceState } from "./maintenance.state";

export const reducer = createReducer(
	initialMaintenanceState,
	on(setMaintenanceTime, (state, { maintenanceTime }) => ({
		...state,
		maintenanceTime: maintenanceTime
	})),
	on(clearMaintenanceTime, () => initialMaintenanceState)
);
